import * as React from 'react';
export const IcRoutes = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 15h-4a3 3 0 00-3 3 1 1 0 01-1 1H7a1 1 0 100 2h4a3 3 0 003-3 1 1 0 011-1h4a1 1 0 000-2zm-2-2a1 1 0 00.71-.29C18 12.37 21 9.34 21 6.8A3.93 3.93 0 0017 3a3.93 3.93 0 00-4 3.8c0 2.54 3 5.57 3.29 5.91A.998.998 0 0017 13zm-1-6a1 1 0 112 0 1 1 0 01-2 0zM7 17a1 1 0 00.71-.29C8 16.37 11 13.34 11 10.8A3.93 3.93 0 007 7a3.93 3.93 0 00-4 3.8c0 2.54 3 5.57 3.29 5.91A.999.999 0 007 17zm-1-6a1 1 0 112 0 1 1 0 01-2 0z'
      fill='currentColor'
    />
  </svg>
);
